module.exports = __webpack_public_path__ + "img/prod.05017cfd.png";